import React from "react";
import ReactCursorPosition from "react-cursor-position";
import { Element } from "react-scroll";
import Footer from "../components/layouts/Footer";
import Demos from "./Demos";
import Homesection from "./Homesection";

function Demopage() {
  document.body.classList.remove("dark");

  return (
    <>
      <main className="content-3">
        <Element name="section-home">
          <ReactCursorPosition>
            <Homesection />
          </ReactCursorPosition>
        </Element>
        <Element name="section-demo">
          <Demos />
        </Element>
      </main>
      <Footer />
    </>
  );
}

export default Demopage;
